module.exports = __webpack_public_path__ + "img/penguin.311aec96.svg";